import { render } from "./vdvclist.vue?vue&type=template&id=7b000af8&scoped=true"
import script from "./vdvclist.vue?vue&type=script&lang=js"
export * from "./vdvclist.vue?vue&type=script&lang=js"

import "./vdvclist.vue?vue&type=style&index=0&id=7b000af8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b000af8"]])

export default __exports__